import React from 'react';
import Breadcrumb, {BreadcrumbListModel} from "../../shared/ui/breadcrumb/Breadcrumb";
import {useRoute} from "../routes/useRoute";
import {useLocation} from "react-router-dom";


export function AuthLayout({children, breadcrumbList}: {
    children?: React.ReactElement,
    breadcrumbList?: BreadcrumbListModel[],
}) {
    const {changeRoute} = useRoute()
    const location = useLocation();
    const clickVoiceBreadrumb = (name: string) => {
        changeRoute(name)
    }
    return (
        <div className={'container-fluid'}>
            {breadcrumbList && breadcrumbList.length &&
                <div className={'row justify-content-center mb-2'}>
                    <div className="col-12">
                        <Breadcrumb list={breadcrumbList} clickVoiceHandler={clickVoiceBreadrumb}
                                    nameActive={location?.pathname}/>
                    </div>
                </div>}
            {children}
        </div>
    );
}
